export default __webpack_public_path__ + "static/media/getting_started1.430b67f9.png";